import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TAnzenKanriGetRes,
  TAnzenKanriListGetReq,
  TAnzenKanriListGetRes,
  TAnzenKanriPostReq,
  TAnzenKanriPutReq,
  TAnzenKanriZissiListGetReq,
  TAnzenKanriZissiListGetRes,
} from "./TAnzenKanri"

/**
 * 安全会議に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class AnzenKanriService extends ConnectApi {
  /**
   * 安全管理情報一覧取得
   *
   * @param {TAnzenKanriListGetReq} params
   * @memberof ZyomuinAnzenKanriService
   */
  getKanriList = async (params: TAnzenKanriListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAnzenKanriListGetRes[]>> =
        await this.getInner(`/driver/anzenkanrilist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 安全管理実施情報一覧取得
   *
   * @param {TAnzenKanriListZissiGetReq} params
   * @memberof ZyomuinAnzenKanriService
   */
  getZissiList = async (params: TAnzenKanriZissiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TAnzenKanriZissiListGetRes[]>> =
        await this.getInner(`/driver/anzenzissilist`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 安全会議情報取得
   *
   * @param id 安全管理情報ID
   * @memberof ZyomuinAnzenKanriService
   */
  get = async (id: number | string, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TAnzenKanriGetRes>> =
        await this.getInner(`/driver/anzenkanrilist/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 安全会議削除
   *
   * @param {string} modifiedDt
   * @memberof ZyomuinAnzenKanriService
   */
  deleteAnzenKanri = async (id: number, modifiedDt: string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.deleteInner(
        `/driver/anzenkanrilist/${id}`,
        {
          更新日時: modifiedDt,
        }
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 安全会議更新
   *
   * @param {TAnzenKanriPutReq} data
   * @memberof ZyomuinAnzenKanriService
   */
  putAnzenKanri = async (id: number, data: TAnzenKanriPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/driver/anzenkanrilist/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 安全会議登録
   *
   * @param {TAnzenKanriPostReq} data
   * @memberof ZyomuinAnzenKanriService
   */
  postAnzenKanri = async (data: TAnzenKanriPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/driver/anzenkanrilist`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
